import 'whatwg-fetch'
import {
  API_URL
} from '../constants/configValues'

const hub = {
  fetchHubs(token, systemID) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/hubs/list`, {
        method: 'GET',
        headers: headerJson
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({
            status: response.status,
            statusText: response.statusText
          })
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  postHub(token, systemID, hub) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/hubs/create`, {
        method: 'POST',
        headers: headerJson,
        body: JSON.stringify(hub)
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({
            status: response.status,
            statusText: response.statusText
          })
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  updateHub(token, systemID, hub) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/hubs/update`, {
        method: 'POST',
        headers: headerJson,
        body: JSON.stringify(hub)
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({
            status: response.status,
            statusText: response.statusText
          })
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteHub(token, systemID, hub) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/hubs/delete/${hub.ID}`, {
        method: 'DELETE',
        headers: headerJson
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({
            status: response.status,
            statusText: response.statusText
          })
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  uploadHub(token, systemID, newFirmware) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/hubs/upload-firmware`, {
        method: 'POST',
        headers: headerJson,
        body: JSON.stringify(newFirmware)
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({
            status: response.status,
            statusText: response.statusText
          })
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  upgradeHub(token, systemID, upgradeList) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/hubs/firmware-download-enable`, {
        method: 'POST',
        headers: headerJson,
        body: JSON.stringify(upgradeList)
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({
            status: response.status,
            statusText: response.statusText
          })
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}
export default hub



// WEBPACK FOOTER //
// ./src/api/hub.js